<template>
  <v-container>
    <v-layout>
      <v-flex xs12 sm10 md8 offset-sm1 offset-md2>
        <div class="history-page iabf-dancer-theme">
          <router-link to="/" class="back-link">&larr; Back to Dashboard</router-link>

          <template v-if="hasPastFestivalYears">
            <header class="history-hero">
              <p class="history-kicker">Your IABF years</p>
              <h1 class="history-title">Festival history</h1>
              <p class="history-lede">
                Showcase pieces, performance recordings, and competition results from every year you’ve been with us.
              </p>
            </header>
            <festival-history />
          </template>
          <template v-else>
            <header class="history-hero">
              <h1 class="history-title">Festival history</h1>
              <p class="history-lede">
                This is your first IABF — after the festival, your pieces and
                recordings will live here.
              </p>
            </header>
          </template>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import FestivalHistory from '@/components/iabf/FestivalHistory.vue'
import { hasPastFestivalYears as dancerHasPastFestivalYears } from '@/utils/iabf-festival-history'
import { yearsAttendedForDancer } from '@/utils/iabf-attendance-years'

export default {
  name: 'IABFHistory',
  components: { FestivalHistory },
  computed: {
    hasPastFestivalYears () {
      const person = this.$store.getters.currentIABFPerson || {}
      const d = this.$store.getters.currentIABFDancer || {}
      return dancerHasPastFestivalYears({
        yearsAttended: yearsAttendedForDancer(person, d, d.festivalYear),
        enrollmentYear: d.festivalYear,
        isCanceledAccount: !!d.isCanceledAccount,
        canceledYears: d.canceledYears
      })
    }
  },
  created () {
    this.$store.commit('setLayout', 'iabf-layout')
  }
}
</script>

<style scoped>
.history-page {
  padding: 8px 0 48px;
}
.back-link {
  display: inline-block;
  margin-bottom: 16px;
  color: var(--iabf-primary, #8a957d);
  text-decoration: none;
  font-size: 15px;
}
.back-link:hover {
  text-decoration: underline;
}
.history-kicker {
  font-size: 13px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--iabf-ink-faint, #8a8792);
  margin: 0 0 6px;
}
.history-title {
  font-family: var(--iabf-font-display, Georgia, serif);
  font-weight: 400;
  font-size: 28px;
  color: var(--iabf-ink, #1c1b1f);
  margin: 0 0 8px;
}
.history-lede {
  color: var(--iabf-ink-muted, #5c5a63);
  font-size: 16px;
  line-height: 1.5;
  margin: 0 0 24px;
}
</style>
